//export const API_URL = "http://resultados-admisiones.unicartagena.edu.co:8080";
export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8081";

export const getURL = ({
  type,
  offer,
  program,
}: {
  type: string;
  offer: string;
  program: string;
}) => {
  const offerCode = String(offer).padStart(10, "0");

  const endpoints = {
    ADMISSION: `/api/reports?offer=${offerCode}`,
    SYSTEM: `/api/reports/system?offer=${offerCode}`,
    AUDIT: `/api/reports/audit?offer=${offerCode}`,
    SUBJECT: `/api/reports/califications?offer=${offerCode}`,
    GENERAL: `/api/statistics/general?offer=${offerCode}&program=${program}`,
    SCORE: `/api/statistics/score?offer=${offerCode}&program=${program}`,
    SNP: `/api/candidates/icfes?snp=${offer}&program=${program}`,
    STT_SUBJECT: `/api/statistics/subject?offer=${offerCode}&program=${program}`,
    MATCH: `/api/reports/icfes-data?offer=${offerCode}`,
    REVIEW: `/api/reports/icfes-data/review?offer=${offerCode}`,
    OFFERS: `/api/offers`,
    OFFER_PROGRAMS: `/api/offers/${offer}/programs`,
    FACULTIES: `/api/faculties`,
    PROGRAMS: `/api/programs`,
    CALCULATION_MODELS: `/api/icfes/models`,
    SCORES: `/api/scores?offer=${offerCode}`,
    QUOTAS: `/api/quotas?offer=${offerCode}`,
    QUOTAS_POST: `/api/quotas`,
    ENROLLMENT_STATE: `/api/dashboard/enrollments/state?offer=${offerCode}`,
    ENROLLMENT_PROGRAM: `/api/dashboard/programs?offer=${offerCode}`,
    GENERAL_METRICS: `/api/dashboard/general?offer=${offerCode}`,
    MODALITIES_ADMISSION_RATE: `/api/dashboard/modalities?offer=${offerCode}`,
    USERS: `/api/users`,
    ICFES_FILES: `/api/icfes/files`,
    CANDIDATES_EXCEL: `/api/candidates/excel`,
    CANDIDATES_BY_ADMISSION_STATE: `/api/candidates/by-admission-state?offer=${offerCode}&admissionState=${program}`,
    CANDIDATES_WITH_ESTABLECIMIENTO: `/api/candidates/with-establecimiento?offer=${offerCode}`,
    CANDIDATES_BY_OFFER: `/api/candidates?offer=${offerCode}`,
  };

  console.log(type);
  const endpoint = endpoints[type as keyof typeof endpoints];
  return `${API_URL}${endpoint}`;
};

export const getURLPaging = ({
  type,
  offer,
  program: _program,
  page,
  size,
}: {
  type: string;
  offer: string;
  program: string;
  page: number;
  size: number;
}) => {
  const offerCode = String(offer).padStart(10, "0");

  const endpoints = {
    ADMISSION: `/api/reports/page?offer=${offerCode}&page=${page}&size=${size}`,
  };

  const endpoint = endpoints[type as keyof typeof endpoints] || `/api/admission?offer=${offerCode}`;
  return `${API_URL}${endpoint}`;
};
